import React from 'react';

import CallToActionWidget from 'applications/static-pages/cta-widget';

const ServiceAvailabilityBanner = () => {
  return (
    <>
      <CallToActionWidget appId="gi-bill-benefits" />
    </>
  );
};

export default ServiceAvailabilityBanner;
